<template>
    <v-container fluid>
        <div v-if="isLoaded">
            <div v-if="research">
                <v-row justify="end">
                    <information :text="`${text[locale.split('-')[0]]}`" />
                </v-row>
                <!--table head-->
                <v-divider color="black" />
                <v-row class="subtitle-2 my-1" no-gutters>
                    <v-col v-for="(item, i) in headers" :key="i"
                        :class="item.style"
                        :cols="item.cols">
                        {{ `${item.title}` | localize }}
                    </v-col> 
                </v-row>
                <v-divider color="black" />

                <!--media-costs row-->
                <div v-if="matched_insights?.length">
                    
                    <div v-for="item in matched_insights" :key="item.id">
                        <v-row class="body-2 my-1" no-gutters>
                            <v-col cols="1" class="text-left">{{ item.segment?.name }}</v-col>
                            <v-col cols="1" class="text-center">{{ item.weight }}</v-col>
                            <v-col cols="10" class="text-center">{{ item.text }}</v-col>                        
                        </v-row>
                        <v-divider />
                    </div>
                </div>
                <v-row v-else class="mt-8 px-4" justify="center">
                    there aren't insights!
                </v-row>
            </div>
            <v-row v-else class="my-12 subtitle-1 secondary--text" justify="center">
                To see insights on the segments you're interested in, you have to order the report under the resources tab!
            </v-row>
        </div>
        <v-row v-else justify="center" class="mt-12">
            <loader />
        </v-row>
    </v-container>
</template>
<script>
import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue';

export default {
    name: 'Insights',
    data() {
        return {
            headers: [
                { title: 'Segment', style: 'text-left', cols: 1 },
                { title: 'Weight', style: 'text-center', cols: 1 },
                { title: 'Insight', style: 'text-center', cols: 10 },
            ],
            isLoaded: false,
            text: {
                en: 'Insights into expected product characteristics reflect the features and attributes consumers may require or prioritise in future product offerings.',
                ro: 'Analiza caracteristicilor preconizate ale produselor reflectă trăsăturile și atributele pe care consumatorii le-ar putea solicita sau considera prioritare în viitoarele oferte de produse.',
                ru: 'Анализ ожидаемых характеристик продукта отражает те особенности и свойства, которые потребители могут требовать или считать приоритетными в будущих предложениях.'
            }
        }
    },
    computed: {
        locale() {
            return this.$store.getters.locale;
        },
        team() {
			return this.$store.getters.team;
		},
		game() {
			return this.$store.getters.game;
		},
        insights() {
            return this.$store.getters.insights;
        },
        resources () {
            return this.$store.getters.resources_team;
        },
        research () {
            let res = null;
            if (this.resources?.length > 0) {
                res = this.resources[0]?.research_segments;
            }
            return Boolean(res);
        },
        matched_insights() {
            let res_arr = [];
            if (this.resources?.length > 0) {
                this.insights?.forEach((item) => {
                    const inResource = this.resources[0].research_segments.find((seg) => seg == item.segment.name);
                    if (inResource) {
                        res_arr.push(item)
                    }
                })
            }
            return res_arr;
        }

    },
    methods: {
    },
    components: {
        Loader, Information
    },
    async created() {
			
        if (this.game && this.team) { 
			
			const params = {
				gameId: this.game.id,
				round: Number(this.game.round),
				teamId: this.team.id,
			}

            if (this.resources == null) {
                try {
                    await this.$store.dispatch('fetchTeamResources', params);
                } catch (error) {
                    await this.$store.dispatch('setError', error.message)
                }
            }

            if (this.insights == null) {
                try {
                    await this.$store.dispatch('fetchInsights', { gameId: this.game.id });
                } catch (error) {
                    await this.$store.dispatch('setError', error.message);
                }
            } 
		}
		this.isLoaded = true;
	}
}
</script>